import { Position } from "reactflow";
import { INodeData } from "../../index";
import { Box } from "@mui/material";
import CustomHandler from "../../Helpers/CustomHandler";


export default function NodeTarefa({ data }: INodeData) {
    return (
        <Box position="relative">
            <CustomHandler type="target" id="target-left" position={Position.Left} />
            <CustomHandler type="target" id="target-bottom" position={Position.Bottom} />
            <Box
                bgcolor="#fff"
                border={`2px solid rgba(0,0,0, ${data.isClicked ? "0.7" : "0.2"})`}
                height={60}
                width={200}
                display="flex"
                alignItems="center"
                justifyContent="center"
            >
                <Box sx={{ textAlign: 'center', fontSize: 10 }}>{data.titulo}</Box>
            </Box>
            <CustomHandler type="source" id="source-right" position={Position.Right} />
            <CustomHandler type="source" id="source-top" position={Position.Top} />
        </Box>
    )
}